import * as React from "react";
import { forwardRef } from "react";
const SvgIconAreaZoom = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 17, fill: "none", viewBox: "0 0 17 17", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.06 1H2a1 1 0 0 0-1 1v4.06M16 6.06V2a1 1 0 0 0-1-1h-4.06M10.94 16H15a1 1 0 0 0 1-1v-4.06M1 10.94V15a1 1 0 0 0 1 1h4.06", stroke: "#fff", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M10.94 6.06 16 1M1 16l5.06-5.06", stroke: "#fff", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgIconAreaZoom);
export default ForwardRef;
